import { render } from "./DeployVM.vue?vue&type=template&id=0dc678a4&scoped=true"
import script from "./DeployVM.vue?vue&type=script&lang=js"
export * from "./DeployVM.vue?vue&type=script&lang=js"

import "./DeployVM.vue?vue&type=style&index=0&id=0dc678a4&lang=less&scoped=true"
import "./DeployVM.vue?vue&type=style&index=1&id=0dc678a4&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc678a4"]])

export default __exports__